export default __webpack_public_path__ + "static/media/warning.81681d0c.svg";